import { checkThirdPartyTrackingStorageInit } from '../../configParametersRepository/storageClient';
import { updateCustomParamsAndDimensions } from '../customDimensionsRepository/storageSync';
import { fireEvent } from '../tag-commander/datalayer';
import type { Datalayer } from '../tag-commander/types';
import { trackEvent } from './events';
import { trackGA4Promo } from './promotions';
import { trackQualtrics } from './surveys';
import type {
  CustomDimension,
  ParsedCustomDimensions,
  RouteOptions,
  SetCustomDimensionsArgs,
  ThirdPartyTrackingAgent,
  ThirdPartyTrackingAgentArgs,
} from './types';
import trackWebVitals from './webVitals';

const parseSetCustomDimensionArgs = (
  args: SetCustomDimensionsArgs | [ParsedCustomDimensions]
): ParsedCustomDimensions => {
  if (typeof args[0] === 'number' || typeof args[0] === 'string') {
    return {
      dimension: args[0],
      value: args[1] || '',
    };
  }
  return args[0];
};

export const routeOptions: RouteOptions = {
  pageMap: {},
  matcher: {
    getPathParams: () => ({}),
    findMatchingPattern: () => undefined,
  },
};

export const createThirdPartyTrackingAgent = ({
  trackSurvey,
  trackPage,
  routePageMap,
  routeMatcher,
}: ThirdPartyTrackingAgentArgs): ThirdPartyTrackingAgent => {
  routeOptions.matcher = routeMatcher;
  routeOptions.pageMap = routePageMap;

  const setCustomDimension = (...args: SetCustomDimensionsArgs) => {
    checkThirdPartyTrackingStorageInit();
    if (typeof window === 'undefined') return;
    const { dimension, value } = parseSetCustomDimensionArgs(args);
    const uaDimension = String(dimension).match(
      /^[1-9](\d)?$/
    )?.[0] as CustomDimension;
    if (uaDimension) {
      updateCustomParamsAndDimensions({
        [`dimension${uaDimension}`]: value,
      });
    } else {
      updateCustomParamsAndDimensions({
        [dimension]: value,
      });
    }
  };

  return {
    trackQualtrics,
    trackSurvey,
    trackFireEvent: (
      category: string,
      key?: keyof Datalayer,
      value?: Datalayer[keyof Datalayer]
    ) => {
      void fireEvent({
        event_category: category,
        ...(key && { [key]: value }),
      });
    },
    trackPage,
    setCustomDimension,
    trackEvent,
    trackPromotion: trackGA4Promo,
    trackWebVitals,
  };
};
